var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTiktokWhite = function SvgTiktokWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tiktok-white-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_6",
    "data-name": "Exclusion 6",
    d: "M-3853,692h-18V674h18v18Zm-10.137-11.065a3.812,3.812,0,0,0-1.426.3,4.034,4.034,0,0,0-1.149.68,4.417,4.417,0,0,0-.967,1.182,4.1,4.1,0,0,0-.5,1.884,4.458,4.458,0,0,0,.243,1.486,4.4,4.4,0,0,0,.615,1.118,4.534,4.534,0,0,0,.324.367l0,.006a4.223,4.223,0,0,0,2.3.688,4.139,4.139,0,0,0,1.711-.376,4.158,4.158,0,0,0,2.145-2.288,4.636,4.636,0,0,0,.273-1.429v-4.6c.027.019.389.256.393.258a5.208,5.208,0,0,0,1.344.553,7.762,7.762,0,0,0,1.377.188v-1.744a3.6,3.6,0,0,1-.762-.28,3.459,3.459,0,0,1-.912-.7,3.673,3.673,0,0,1-.665-.562,3.1,3.1,0,0,1-.749-1.535h-1.634v8.675a2.591,2.591,0,0,1-.1.893,1.789,1.789,0,0,1-.982,1.08,1.9,1.9,0,0,1-.794.173,1.926,1.926,0,0,1-1.534-.766,2.607,2.607,0,0,1-.231-.138,1.891,1.891,0,0,1-.793-1.576,1.891,1.891,0,0,1,.85-1.545,1.934,1.934,0,0,1,1.055-.312,1.944,1.944,0,0,1,.56.082v-1.766Z",
    transform: "translate(3871 -674)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTiktokWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiktok-white.409ac6ff.svg";
export { ForwardRef as ReactComponent };